import axios from '@/axios'

// Volumes
export function newVolumes (data) {
  return axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/volumes', data)
}

export async function listVolumes () {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/volumes')
  return response.data.data
}

export async function getVolume (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/volumes/' + id)
  return response.data.data
}

export function updateVolumes (id, data) {
  return axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/volumes/' + id, data)
}

export function deleteVolumes (id) {
  return axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/volumes/' + id)
}

export async function listVolumesByTeachingSystemAndGradeLevel (teachingSystemId, gradeLevelId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/teaching-systems/' + teachingSystemId + '/grade-levels/' + gradeLevelId + '/volumes/')
  return response.data.data
}

export async function addVolumeByTeachingSystemAndGradeLevel (teachingSystemId, gradeLevelId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/teaching-systems/' + teachingSystemId + '/grade-levels/' + gradeLevelId + '/volumes/', data)
  return response
}

export async function deleteVolumeByTeachingSystemAndGradeLevel (teachingSystemId, gradeLevelId, volumeId) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/teaching-systems/' + teachingSystemId + '/grade-levels/' + gradeLevelId + '/volumes/' + volumeId)
  return response
}

export default {
  newVolumes,
  listVolumes,
  getVolume,
  updateVolumes,
  deleteVolumes,
  listVolumesByTeachingSystemAndGradeLevel,
  addVolumeByTeachingSystemAndGradeLevel,
  deleteVolumeByTeachingSystemAndGradeLevel
}
